








































































































































































































































































































































































import { apiPageConfigGetStateContentByApp as _apiPageConfigGetStateContentByApp } from '@/api'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApiPlus, useShareParams } from '@/hooks'
import { devOrProd, requiredDeep, Track } from '@/utils'
import { loadResource, LoadResourceUrlType } from 'vtils'
import { XWaterfallLoad } from '@/components'

const apiPageConfigGetStateContentByApp = _apiPageConfigGetStateContentByApp

export default defineClassComponent(
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '夏日漂流季',
        }))
      }

      shareParams = useShareParams(
        devOrProd(
          '8aaa9213826d16b701827bbf381c0000',
          '8aaae032826d8a6d01827bc0b2f00002',
        ),
      )

      loading = computed(() => this.apiData.loading)

      apiData = useApiPlus({
        配置数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa8ea28258ee4e01827b12bdde0408',
            pageIndex: 1,
            pageSize: 8,
          })
            .then(requiredDeep)
            .then(res => res.list)
            .then(async list => {
              await loadResource({
                path: list[0].icon,
                type: LoadResourceUrlType.img,
              })
              return list
            }),
        杉木河数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa8ea28258ee4e01827b18c2fc040b',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res =>
              res.list.slice(0, 9).map(item => ({
                ...item,
                tags: (((item.remarkMap as any).Labels as string) || '')
                  .split(',')
                  .filter(Boolean),
              })),
            ),
        高过河数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa8ea28258ee4e01827b19e8b6040e',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res =>
              res.list.slice(0, 9).map(item => ({
                ...item,
                tags: (((item.remarkMap as any).Labels as string) || '')
                  .split(',')
                  .filter(Boolean),
              })),
            ),
        马岭河数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa8ea28258ee4e01827b20ffdb041a',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res =>
              res.list.slice(0, 9).map(item => ({
                ...item,
                tags: (((item.remarkMap as any).Labels as string) || '')
                  .split(',')
                  .filter(Boolean),
              })),
            ),
        桃源河数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa8ea28258ee4e01827b220dbd041e',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res =>
              res.list.slice(0, 9).map(item => ({
                ...item,
                tags: (((item.remarkMap as any).Labels as string) || '')
                  .split(',')
                  .filter(Boolean),
              })),
            ),
        漂流伴侣数据: () =>
          apiPageConfigGetStateContentByApp({
            stateId: '8aaa8ea28258ee4e01827b23f16c0422',
            pageIndex: 1,
            pageSize: 10,
          })
            .then(requiredDeep)
            .then(res =>
              res.list.slice(0, 8).map(item => ({
                ...item,
                tags: (((item.remarkMap as any).Labels as string) || '')
                  .split(',')
                  .filter(Boolean),
              })),
            ),
      })

      配置数据 = computed(() => ({
        头图: this.apiData.data.配置数据[0],
        杉木河标题: this.apiData.data.配置数据[1],
        高过河标题: this.apiData.data.配置数据[2],
        马岭河标题: this.apiData.data.配置数据[3],
        桃源河标题: this.apiData.data.配置数据[4],
        漂流伴侣标题: this.apiData.data.配置数据[5],
        漂流小贴士标题: this.apiData.data.配置数据[6],
        漂流小贴士更多: this.apiData.data.配置数据[7],
      }))

      杉木河数据 = computed(() => this.apiData.data.杉木河数据)

      高过河数据 = computed(() => this.apiData.data.高过河数据)

      马岭河数据 = computed(() => this.apiData.data.马岭河数据)

      桃源河数据 = computed(() => this.apiData.data.桃源河数据)

      漂流伴侣数据 = computed(() => this.apiData.data.漂流伴侣数据)

      handleLoad: XWaterfallLoad = ({ pageNumber }) => {
        return apiPageConfigGetStateContentByApp({
          stateId: '8aaa8ea28258ee4e01827b2509750426',
          pageIndex: pageNumber,
          pageSize: 10,
        }) as any
      }
    },
)
